import { CanDeactivateFn } from '@angular/router';

interface UnsavedChangesAware {
  canDeactivate: () => boolean;
}

export const questionnaireBuilderUnsavedGuard: CanDeactivateFn<
  UnsavedChangesAware
> = (component) => component.canDeactivate();
